<template>
  <div class="loading-complete">
    <div ref="checkmark" class="checkmark draw"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingComplete',
  mounted () {
    setTimeout(() => {
      this.$refs.checkmark.style.display = 'block'
    }, 200)
  }
}
</script>

<style lang="scss">

  $brand-success: $green;
  $loader-size: 22px;
  $check-height: $loader-size/2;
  $check-width: $check-height/2;
  $check-left: ($loader-size/6 + $loader-size/12);
  $check-thickness: 3px;
  $check-color: $brand-success;

  .loading-complete {
    position: relative;
    width: $loader-size;
    height: $loader-size;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .checkmark {
    display: none;

    &.draw:after {
      animation-duration: 800ms;
      animation-timing-function: ease;
      animation-name: checkmark;
      transform: scaleX(-1) rotate(135deg);
    }

    &:after {
      opacity: 1;
      height: $check-height;
      width: $check-width;
      transform-origin: left top;
      border-right: $check-thickness solid $check-color;
      border-top: $check-thickness solid $check-color;
      content: '';
      left: $check-left;
      top: $check-height;
      position: absolute;
    }
  }

  @keyframes checkmark {
    0% {
      height: 0;
      width: 0;
      opacity: 1;
    }
    20% {
      height: 0;
      width: $check-width;
      opacity: 1;
    }
    40% {
      height: $check-height;
      width: $check-width;
      opacity: 1;
    }
    100% {
      height: $check-height;
      width: $check-width;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/loaders/LoadingComplete.vue